import {AbstractController} from "./abstract-controller";
import {BwFilters, BwObjectPromise} from "../../service/global.service";
import { Environment } from "../environment";

export class CompromiseReportsController extends AbstractController{
  /** Second part of url for compromise reports (policy violations) */
  private readonly service:string="api/v1.0/policy-violations";
  private readonly apiUrl: keyof Environment = "bwApiUrl";

  public async search(filters:BwFilters): Promise<BwObjectPromise>{
    return await this.network.post(`${this.service}/search`, filters, this.apiUrl);
  }
}
